import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  tabs: {
    minHeight: '40px',
    width: '100%',
    borderBottom: `1px solid ${semanticColors.border.tertiary}`,
    '& .MuiTabs-indicator': {
      backgroundColor: semanticColors.foreground.action,
      bottom: 0
    },
    '& .MuiTabs-scroller': {
      paddingLeft: '24px',

    }
  },
  tab: {
    minHeight: '40px',
    padding: '4px',
    marginRight: '24px',
    color: semanticColors.foreground.secondary,
    fontWeight: 400,
    textTransform: 'none',
    fontSize: '14px',
    '&:hover': {
      color: semanticColors.foreground.action
    }
  },
  activeTab: {
    minHeight: '40px',
    padding: '4px 0',
    marginRight: '24px',
    color: semanticColors.foreground.action,
    fontWeight: 700,
    textTransform: 'none',
    fontSize: '14px'
  }
});
